module.exports = file => () => import('@/page' + file + '.vue')
